(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/components/banner.js
  var _Banner = class {
    static init() {
      const banner = window.Store.app.theBody.querySelector(_Banner.params.selectors.el);
      if (!banner) {
        return false;
      }
      const obj = new _Banner(banner);
      obj.init();
      return obj;
    }
    constructor(element) {
      this.elements = {
        el: element,
        close: element.querySelector(_Banner.params.selectors.close)
      };
      this.active = false;
    }
    init() {
      if (this.elements.close) {
        this.elements.close.addEventListener("click", this.toggle.bind(this));
      }
      this.setVisibility();
    }
    toggle(e) {
      e.preventDefault();
      this.setActive(false);
      this.setStorage();
      this.dispatchEvent();
    }
    setVisibility() {
      if (this.getStorage()) {
        const recordedDate = new Date(this.getStorage());
        if (this.currentDate > recordedDate) {
          this.deleteStorage();
          this.setActive(true);
        }
      } else {
        this.setActive(true);
      }
    }
    setActive(status) {
      this.active = status;
      this.elements.el.classList.toggle(_Banner.params.modifiers.active, status);
    }
    dispatchEvent() {
      const event = new CustomEvent("bannerupdate");
      document.dispatchEvent(event);
    }
    getStorage() {
      return window.localStorage.getItem(_Banner.params.selectors.storage);
    }
    setStorage() {
      window.localStorage.setItem(_Banner.params.selectors.storage, this.currentDate.toDateString());
    }
    deleteStorage() {
      window.localStorage.removeItem(_Banner.params.selectors.storage);
    }
    get currentDate() {
      const current = new Date();
      current.setHours(0, 0, 0, 0);
      return current;
    }
  };
  var Banner = _Banner;
  __publicField(Banner, "params", {
    selectors: {
      el: ".js-banner",
      close: ".js-banner-close",
      storage: "banner"
    },
    modifiers: {
      active: "is-active"
    }
  });
  function render() {
    window.Store.components.banner.obj = Banner.init();
  }
  window.Store.components.banner.render = render;
})();
